import { useState, useEffect } from 'react';
import AuthModal from '../../../components/feature/AuthModal';
import UserMenu from '../../../components/feature/UserMenu';
import { supabase } from '../../../supabaseClient';

export default function Header() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      const { data: profile } = await supabase
        .from('profiles')
        .select('is_admin')
        .eq('id', user.id)
        .single();
      
      setIsAdmin(profile?.is_admin || false);
    }
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-40 bg-gray-900/95 backdrop-blur-md border-b border-red-500/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-8">
              <a href="/" className="flex items-center gap-3 cursor-pointer group">
                <img 
                  src="https://static.readdy.ai/image/0fd6964275a81c388ff72e68feed9136/a018590a7ae8642e6d17626a8511e5eb.png" 
                  alt="Revenant League" 
                  className="h-10 w-auto group-hover:scale-105 transition-transform"
                />
              </a>

              <nav className="hidden md:flex items-center gap-6">
                <a href="/training" className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  Training
                </a>
                <a href="/tournaments" className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  Tournaments
                </a>
                <a href="/clips" className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  Clips
                </a>
                <a href="/streams" className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  Streams
                </a>
                <a href="/leaderboard" className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  Leaderboard
                </a>
                <a href="/forums" className="text-gray-300 hover:text-red-400 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium">
                  Forums
                </a>
                {isAdmin && (
                  <a href="/admin" className="text-red-400 hover:text-red-300 transition-colors cursor-pointer whitespace-nowrap text-sm font-bold flex items-center gap-1">
                    <i className="ri-shield-star-line"></i>
                    Admin
                  </a>
                )}
              </nav>
            </div>

            <div className="flex items-center gap-4">
              <UserMenu onSignInClick={() => setShowAuthModal(true)} />
              
              {/* Mobile Menu Button */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors cursor-pointer"
                aria-label="Toggle menu"
              >
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <nav className="md:hidden py-4 border-t border-gray-800">
              <div className="flex flex-col gap-2">
                <a 
                  href="/training" 
                  className="text-gray-300 hover:text-red-400 hover:bg-gray-800 px-4 py-3 rounded-lg transition-colors cursor-pointer font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="ri-trophy-line mr-3"></i>
                  Training
                </a>
                <a 
                  href="/tournaments" 
                  className="text-gray-300 hover:text-red-400 hover:bg-gray-800 px-4 py-3 rounded-lg transition-colors cursor-pointer font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="ri-trophy-line mr-3"></i>
                  Tournaments
                </a>
                <a 
                  href="/clips" 
                  className="text-gray-300 hover:text-red-400 hover:bg-gray-800 px-4 py-3 rounded-lg transition-colors cursor-pointer font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="ri-video-line mr-3"></i>
                  Clips
                </a>
                <a 
                  href="/streams" 
                  className="text-gray-300 hover:text-red-400 hover:bg-gray-800 px-4 py-3 rounded-lg transition-colors cursor-pointer font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="ri-live-line mr-3"></i>
                  Streams
                </a>
                <a 
                  href="/leaderboard" 
                  className="text-gray-300 hover:text-red-400 hover:bg-gray-800 px-4 py-3 rounded-lg transition-colors cursor-pointer font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="ri-bar-chart-line mr-3"></i>
                  Leaderboard
                </a>
                <a 
                  href="/forums" 
                  className="text-gray-300 hover:text-red-400 hover:bg-gray-800 px-4 py-3 rounded-lg transition-colors cursor-pointer font-medium"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <i className="ri-chat-3-line mr-3"></i>
                  Forums
                </a>
                {isAdmin && (
                  <a 
                    href="/admin" 
                    className="text-red-400 hover:text-red-300 hover:bg-gray-800 px-4 py-3 rounded-lg transition-colors cursor-pointer font-bold"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <i className="ri-shield-star-line mr-3"></i>
                    Admin Dashboard
                  </a>
                )}
              </div>
            </nav>
          )}
        </div>
      </header>

      {showAuthModal && (
        <AuthModal onClose={() => setShowAuthModal(false)} />
      )}
    </>
  );
}
